module.exports = __webpack_public_path__ + "img/0Q3A5746_L_Wood_MockedUp.1992ecb5.jpg";